/**
 * Locating API — fetches the Inovonics Find Roaming Device embedded widget URL
 * for the current campus. The backend (mysql_fetch.py → `getinolocatewizard`)
 * handles the two-step OAuth + widget URL retrieval; the frontend just
 * unwraps the response and hands the URL to the iframe.
 */
import { apiFetch } from '../../../../../services/api.js';

/**
 * Fetch the Find Roaming Device widget URL for a campus.
 *
 * @param {number} campusId
 * @returns {Promise<string>} — Widget URL, or empty string if unavailable.
 */
export async function fetchLocatingWidgetUrl(campusId) {
    const res = await apiFetch({
        procedure: 'getinolocatewizard',
        reqType: 'stored',
        payload: { campus_id: campusId },
        readOnly: true,
    });
    return res?.[0]?.url || '';
}
